export const RISK_LEVEL_MAP = {
  high: 3,
  medium: 2,
  low: 1,
  unknown: 0,
};

export enum RISK_LEVEL_ENUM {
  high = 'high',
  medium = 'medium',
  low = 'low',
  unknown = 'unknown',
}

export enum RISK_SCORE_ENUM {
  unknown = 'unknown',
  high = 'high',
  medium = 'medium',
  low = 'low',
}

export const RISK_LEVEL_VALUE_TO_LABEL = {
  '3': 'High',
  '2': 'Medium',
  '1': 'Low',
  '0': 'Unknown',
};

export type RISK_LEVEL_VALUE = '3' | '2' | '1' | '0';

export const LOW_RISK_THRESHOLD = 3;
export const MEDIUM_RISK_THRESHOLD = 6;

export function calculateRiskScore(resourceRiskLevel: string, permissionRiskLevel: string) {
  const resource_risk = getRiskLevelFromString(resourceRiskLevel);
  const permission_risk = getRiskLevelFromString(permissionRiskLevel);
  const maxRiskScore = getRiskLevelFromString('high') * getRiskLevelFromString('high');

  const riskScore = resource_risk * permission_risk;
  const riskScoreLabel = getRiskScoreLabel(riskScore);

  return { riskScore, riskScoreLabel, maxRiskScore };
}

export const getRiskLevelFromString = (riskLevel: string): number => {
  const level = riskLevel.toLowerCase();
  if (level in RISK_LEVEL_MAP) {
    return RISK_LEVEL_MAP[level as RISK_LEVEL_ENUM];
  }
  return 0;
};

export function getRiskScoreLabel(riskScore: number): RISK_SCORE_ENUM {
  if (riskScore === 0) {
    return RISK_SCORE_ENUM.unknown;
  } else if (riskScore <= LOW_RISK_THRESHOLD) {
    return RISK_SCORE_ENUM.low;
  } else if (riskScore <= MEDIUM_RISK_THRESHOLD) {
    return RISK_SCORE_ENUM.medium;
  } else {
    return RISK_SCORE_ENUM.high;
  }
}

interface PermissionsRiskLevelSummary {
  highLevelCount: number;
  mediumLevelCount: number;
  lowLevelCount: number;
}

export function calcRiskScoreSummary({
  resourceRiskLevel,
  summary,
}: {
  resourceRiskLevel: string;
  summary: PermissionsRiskLevelSummary;
}) {
  const resourceRiskLevelValue = getRiskLevelFromString(resourceRiskLevel);

  switch (resourceRiskLevelValue) {
    // if its low level
    // then all low * (low or medium or hight) will result in low score
    case RISK_LEVEL_MAP.low:
      return {
        lowScoreCount: summary.lowLevelCount + summary.mediumLevelCount + summary.highLevelCount,
        mediumScoreCount: 0,
        highScoreCount: 0,
      };
    // if its medium level
    // then all medium * (medium or hight) will result in medium score
    // and medium * low will result in low score
    case RISK_LEVEL_MAP.medium:
      return {
        lowScoreCount: summary.lowLevelCount,
        mediumScoreCount: summary.mediumLevelCount + summary.highLevelCount,
        highScoreCount: 0,
      };
    // if its high level
    // then all high * high will result in low score
    // and high * medium will result in medium score
    // and high * low will result in high score
    case RISK_LEVEL_MAP.high:
      return {
        lowScoreCount: summary.lowLevelCount,
        mediumScoreCount: summary.mediumLevelCount,
        highScoreCount: summary.highLevelCount,
      };
    default:
      return {
        lowScoreCount: 0,
        mediumScoreCount: 0,
        highScoreCount: 0,
      };
  }
}
